import React, {useEffect, useState} from 'react'
import axios from 'axios'
import Loader from '../components/Loader'
import PlayerModal from '../components/PlayerModal'
import usePortal from '../hooks/usePortal'
import {createPortal} from 'react-dom'


const Portal = ({id, children}) => {
  const target = usePortal(id)
  return createPortal(
    children,
    target,
  )
}

const apiUrl =
  process.env.NODE_ENV === 'production' ? '/' : 'http://localhost:7075/'
const Rating = () => {
  const [allUsers, setAllUsers] = useState([])
  const [selectUser, setSelectedUser] = useState(null)

  useEffect(() => {
    const getRating = async () => {
      const result = await axios.get(apiUrl + 'wp-json/api/v1/getRating/')
      setAllUsers(result.data.players)
    }

    getRating()
  }, [])


  const closeModal = (e) => {
    e.stopPropagation()
    setSelectedUser('')
  }


  return <div className={'content'}>

    {selectUser && <Portal id={'PlayerModal'}>
      <PlayerModal player={selectUser} hasOverlay  closeModal={closeModal} setSelectedUser={setSelectedUser} />
    </Portal>}

    <h1 className="title-main">
      Рейтинг
    </h1>

    {allUsers.length ? <div className="ratings">
      <table>
        <thead>
        <tr>
          <th>Имя игрока</th>
          <th>Позиция</th>
          <th>Год рождения</th>
          <th>Клуб</th>
        </tr>
        </thead>
        <tbody>
        {
          allUsers.map((user,index) => <tr key={user.title} className={user.bestPlayer ? 'best-player' : null}>
            <td style={{'cursor':'pointer'}} onClick={() => setSelectedUser(user.modal)}><span>{index+1}</span><img src={user.modal.players.iconfootbool.sourceUrl} className={'icon-logo-td'} alt={''}/>{user.title}</td>
            <td style={{textAlign:'center'}}>{user.position}</td>
            <td style={{textAlign:'center'}} className={'hiddentd'}>{user.age}</td>
            <td className={'hiddentd'}>{user.club}</td>
          </tr>)
        }

        </tbody>
      </table>


    </div> : <Loader/>}



    <div className="rating-footer">
      <span>Жирным выделены лучшие на своей позиции</span>


      <div className="rating-footer__items">
        <div className="rating-footer__item">
          В – Вратарь <br />
          ПЦЗ – Правый центральный защитник <br />
          ЛЦЗ – Левый центральный защитник <br />
          ЛЗ – Левый защитник <br />
          ПЗ – Правый защитник <br />
          ОПЗ – Опорный полузащитник
        </div>
        <div className="rating-footer__item">
          ЦП – Центральный полузащитник <br />
          ЦАП – Атакующий полузащитник <br />
          ПП – Правый полузащитник / вингер <br />
          ЛП – Левый полузащитник / вингер <br />
          Н –  Нападающий
        </div>

      </div>



    </div>


  </div>
}

export default Rating
